import src from "IMAGE";
export default { src, width: 901, height: 131, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABc7io0NIlBRCxs+PAoZOjcJFzY0DB5FQwsdREELHUNBaxsGA73v1ysAAAAASUVORK5CYII="};
